function mainRender() {
    $(function () {
        $('#root').css('zoom', 'normal')
        let scale = document.body.clientWidth / 1080;
        $('#root').css('zoom', scale)

        window.addEventListener('resize', function () {
            var timer;
            return function () {
                if (timer) clearTimeout(timer);
                timer = setTimeout(function () {
                    $('#root').css('zoom', 'normal')
                    let scale = document.body.clientWidth / 1080;
                    $('#root').css('zoom', scale)
                }, 100)
            }
        }())
    })


    function lazyLoadImages() { // 懒加载
        const images = document.querySelectorAll('.lazy-load'); // 获取所有需要懒加载的图片
        const config = {
            rootMargin: '0px 0px 1300px 0px',
            threshold: 0
        };

        const lazyLoadObserver = new IntersectionObserver(function (entries, observer) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) { // 当图片进入视口时
                    const image = entry.target;
                    const dataSrc = image.getAttribute('data-src');
                    image.src = dataSrc; // 将data-src属性的值设置为图片的实际地址
                    lazyLoadObserver.unobserve(image); // 停止观察该图片
                }
            });
        }, config);

        images.forEach(function (image) {
            lazyLoadObserver.observe(image); // 开始观察每个图片
        });
    }

    function preloadImages(imageArray) { // 预加载
        // 检查数组数据结构
        if (Array.isArray(imageArray[0])) { // 处理二维数组
            imageArray.forEach(subArray => {
                subArray.forEach(url => {
                    const img = new Image();
                    img.src = url;
                });
            });
        } else { // 处理一维数组
            imageArray.forEach(url => {
                const img = new Image();
                img.src = url;
            });
        }
    }

    document.addEventListener('DOMContentLoaded', function () {
        lazyLoadImages()

        // preloadImages(imagesOneDim)
        // preloadImages(imagesTwoDim)

        // 找到所有跳转套餐的锚点链接
        // 找到所有的锚点链接
        var links = document.querySelectorAll('a[href^="#"]');
        // 为每个链接添加点击事件
        links.forEach(function (link) {
            link.addEventListener("click", function (event) {
                event.preventDefault(); // 阻止默认的跳转行为
                // 找到目标锚点元素
                var targetElement = document.getElementById('shopping');

                // 如果目标元素存在，则滚动到该元素位置
                if (targetElement) {
                    targetElement.scrollIntoView({ behavior: 'smooth', });
                }
            });
        });
    });


    // IOS字体多了间距的处理 给节点添加 sp_system 类名
    // 判断当前用户是安卓端还是iOS端
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;
    // 添加对战斧浏览器的检查
    var isAndroid = /android/i.test(userAgent);
    var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !/MSStream/.test(userAgent) && !/ZhanFu/.test(userAgent);
    var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent) && !/ZhanFu/.test(userAgent);
    
    if (isAndroid) {
        console.log("Android");
    } else if (isIOS) {
        console.log("iOS");
      $('.sp_system').css('letter-spacing', '-2px');
    } else if (isPC) {
        console.log("PC");
    } else {
        console.log("Unknown Device");
        $('.sp_system').css('letter-spacing', '-4px');
    }

    // 逻辑

    $(function () {
        // 数量
          let prods = window.product
      // 初始化
      alignmentFns.initialize()
      $('#2').change(function () {
        var number = Number($('#2').val())
        $(this).parents().siblings('.sp-price').children().children('.new').html((number * Number(prods[0].price) / 100).toFixed(2))
        $(this).parents().siblings('.sp-price').children().children('.old').html((number * Number(prods[0].compare_at_price) / 100).toFixed(2))
        $(this).parents().siblings('.sp-texts').children('.save-text').html((number * Number(prods[0].compare_at_price - prods[0].price) / 100).toFixed(2))
      })
      $('#3').change(function () {
        var number = Number($('#3').val())
        $(this).parents().siblings('.sp-price').children().children('.new').html((number * Number(prods[1].price) / 100).toFixed(2))
        $(this).parents().siblings('.sp-price').children().children('.old').html((number * Number(prods[1].compare_at_price) / 100).toFixed(2))
        $(this).parents().siblings('.sp-texts').children('.save-text').html((number * prods[1].price / 300).toFixed(2))
      })
      $('#4').change(function () {
        var number = Number($('#4').val())
        $(this).parents().siblings('.sp-price').children().children('.new').html((number * Number(prods[2].price) / 100).toFixed(2))
        $(this).parents().siblings('.sp-price').children().children('.old').html((number * Number(prods[2].compare_at_price) / 100).toFixed(2))
        $(this).parents().siblings('.sp-texts').children('.save-text').html((number * prods[2].price / 500).toFixed(2))
      })
      $('#5').change(function () {
        var number = Number($('#5').val())
        $(this).parents().siblings('.sp-price').children().children('.new').html((number * Number(prods[3].price) / 100).toFixed(2))
        $(this).parents().siblings('.sp-price').children().children('.old').html((number * Number(prods[3].compare_at_price) / 100).toFixed(2))
        $(this).parents().siblings('.sp-texts').children('.save-text').html((number * prods[3].price / 1000).toFixed(2))
      })
        // 动画
        $("#goods-image_header_1").show()
        $("#goods-image_header_2").hide()
        let header_flag = false;
        setInterval(() => {
            header_flag = !header_flag
            if (header_flag) {
                $("#goods-image_header_1").hide()
                $("#goods-image_header_2").show()
            } else {
                $("#goods-image_header_1").show()
                $("#goods-image_header_2").hide()
            }
        }, 1000);
 $('.buyNow').click(function(){
        let id = $(this).attr('data-id')
        let num = $(this).siblings('.sp-number').find('input').val()
        window.location.href = '/cart/' + id + ':' + num
   
      })
   
        // $('.buyNow').click(function(){
        //   let id = $(this).attr('data-id')
        //   window.location.href = '/cart/' + id + ':1'
        // })
           $('.logo').click(function(){
          window.location.href = 'https://pxcxu.com/'
        })
    })
}
mainRender()